/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

export default {
    FORGOT_title: "Mot de passe oublié",
    FORGOT_intro: "Saisissez votre adresse email. Si un compte existe, vous recevrez un lien pour "
        + "réinitialiser votre mot de passe.",
    FORGOT_email: "Email",
    FORGOT_emailPlaceholder: "vous@exemple.com",
    FORGOT_submit: "Envoyer le lien",
    FORGOT_sending: "Envoi…",
    FORGOT_back: "Retour à la connexion",
    FORGOT_sentTitle: "Vérifiez votre boîte mail",
    FORGOT_sentMessage: "Si un compte est associé à cette adresse, un email contenant un lien de "
        + "réinitialisation vient d'être envoyé. Ce lien expire dans 30 minutes."
};
